// Tela de jogos.
//
// O que estava errado: os seletores eram so "V 126-107", sem dizer contra
// QUEM; e a sumula empilhava os dois times sem hierarquia, entao o time do
// usuario aparecia enterrado no meio da rolagem.
//
// Agora: cartoes com o escudo do adversario, cabecalho com os dois escudos e o
// placar grande, os destaques do jogo, e a sumula em abas -- o seu time
// primeiro, o adversario a um toque.

import React, { useState } from 'react';
import { dataDaRodada, porExtenso, diaMes } from '../engine/calendario.js';
import { regularRoundsOf } from '../engine/career.js';
import { Crest } from './crest.jsx';
import { formatMinutes, derive } from '../engine/boxscore.js';
import { POSITION_LABEL } from '../engine/players.js';
import { teamById } from '../engine/career.js';

function Linha({ l, destaque }) {
  const d = derive(l);
  const pm = l.plusMinus;
  return (
    <tr className={destaque ? 'me' : ''}>
      <td className="n">{l.name}<span className="sub">{l.position}</span></td>
      <td className="dim">{formatMinutes(l.seconds)}</td>
      <td style={{ fontWeight: 800 }}>{l.pts}</td>
      <td>{l.fgm}/{l.fga}</td>
      <td>{l.tpm}/{l.tpa}</td>
      <td>{l.ftm}/{l.fta}</td>
      <td>{l.orb + l.drb}</td>
      <td>{l.ast}</td>
      <td className="dim">{l.tov}</td>
      <td className={pm > 0 ? 'pos' : pm < 0 ? 'neg' : 'dim'}>{pm > 0 ? '+' : ''}{pm}</td>
      <td className="dim">{(d.tsPct * 100).toFixed(0)}%</td>
    </tr>
  );
}

/** O melhor de cada lado, para o olho pegar o jogo sem ler a tabela toda. */
function Destaque({ side, mine }) {
  const top = [...side.lines].filter((l) => l.seconds > 0)
    .sort((a, b) => b.pts - a.pts)[0];
  if (!top) return null;
  return (
    <div className={`hero ${mine ? 'mine' : ''}`}>
      <div className="hero-nm">{top.name}</div>
      <div className="hero-ln">
        <b>{top.pts}</b> pts · {top.orb + top.drb} reb · {top.ast} ast
      </div>
    </div>
  );
}

export function Partidas({ state }) {
  const [sel, setSel] = useState(0);
  const [ladoAdv, setLadoAdv] = useState(false);

  if (!state.boxscores.length) {
    return (
      <div className="card dim small">
        Nenhuma partida sua ainda. Jogue a primeira rodada e a sumula aparece aqui.
      </div>
    );
  }

  const box = state.boxscores[Math.min(sel, state.boxscores.length - 1)];
  const meuLado = box.home.teamId === state.clubId ? box.home : box.away;
  const advLado = box.home.teamId === state.clubId ? box.away : box.home;
  const venceu = meuLado.score > advLado.score;
  const emCasa = box.home.teamId === state.clubId;
  const periodos = box.home.quarters.map((_, i) => (i < 4 ? `${i + 1}Q` : `PR${i - 3}`));
  // A sumula ja guarda season e round; a data sai deles, sem nada no save.
  const quando = box.round
    ? porExtenso(dataDaRodada(box.season || state.season, box.round, regularRoundsOf(state)))
    : null;
  const mostrado = ladoAdv ? advLado : meuLado;

  return (
    <>
      {/* Cada partida com o escudo de quem enfrentou -- "V 126-107" sozinho nao
          diz nada depois de tres jogos. */}
      {quando && (
        <div className="small dim center" style={{ marginBottom: 8 }}>
          {quando} · rodada {box.round}
        </div>
      )}

      <div className="games-strip">
        {state.boxscores.map((b, i) => {
          const meu = b.home.teamId === state.clubId ? b.home : b.away;
          const adv = b.home.teamId === state.clubId ? b.away : b.home;
          const dia = b.round ? diaMes(dataDaRodada(b.season || state.season, b.round, regularRoundsOf(state))) : null;
          const v = meu.score > adv.score;
          return (
            <button key={i} className={`game-card ${sel === i ? 'on' : ''}`}
              onClick={() => { setSel(i); setLadoAdv(false); }}>
              <Crest team={teamById(state, adv.teamId) || { name: adv.name }} size={26} />
              <span className={`res ${v ? 'pos' : 'neg'}`}>{v ? 'V' : 'D'}</span>
              <span className="pl tabular">{meu.score}-{adv.score}</span>
              {dia && <span className="game-dia">{dia}</span>}
            </button>
          );
        })}
      </div>

      <div className="card">
        <div className="game-head">
          <div className="side">
            <Crest team={teamById(state, meuLado.teamId) || { name: meuLado.name }} size={40} />
            <div className="nm">{meuLado.name}</div>
          </div>
          <div className="mid">
            <div className={`score tabular ${venceu ? 'win' : ''}`}>
              {meuLado.score}<span className="x">×</span>{advLado.score}
            </div>
            <div className="tag-line">
              {venceu ? 'Vitoria' : 'Derrota'} · {emCasa ? 'em casa' : 'fora'}
              {box.overtimes ? ` · ${box.overtimes} prorrogacao` : ''}
            </div>
          </div>
          <div className="side">
            <Crest team={teamById(state, advLado.teamId) || { name: advLado.name }} size={40} />
            <div className="nm">{advLado.name}</div>
          </div>
        </div>

        <div className="scroll" style={{ marginTop: 12 }}>
          <table className="periods">
            <thead>
              <tr><th className="n" />{periodos.map((p) => <th key={p}>{p}</th>)}<th>final</th></tr>
            </thead>
            <tbody>
              {[meuLado, advLado].map((s) => (
                <tr key={s.teamId} className={s.teamId === state.clubId ? 'me' : ''}>
                  <td className="n">{s.name}</td>
                  {s.quarters.map((q, i) => <td key={i} className="dim">{q}</td>)}
                  <td style={{ fontWeight: 800 }}>{s.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="heroes">
          <Destaque side={meuLado} mine />
          <Destaque side={advLado} />
        </div>
      </div>

      <div className="row" style={{ gap: 6, marginBottom: 10 }}>
        <button className={`sm ${!ladoAdv ? 'primary' : 'ghost'}`} style={{ flex: 1 }}
          onClick={() => setLadoAdv(false)}>{meuLado.name}</button>
        <button className={`sm ${ladoAdv ? 'primary' : 'ghost'}`} style={{ flex: 1 }}
          onClick={() => setLadoAdv(true)}>{advLado.name}</button>
      </div>

      <div className="card">
        <div className="scroll">
          <table>
            <thead>
              <tr>
                <th className="n">atleta</th><th>min</th><th>pts</th><th>quadra</th>
                <th>3pt</th><th>ll</th><th>reb</th><th>ast</th><th>er</th><th>+/-</th><th>ts%</th>
              </tr>
            </thead>
            <tbody>
              {[...mostrado.lines].filter((l) => l.seconds > 0)
                .sort((a, b) => b.seconds - a.seconds)
                .map((l) => <Linha key={l.playerId} l={l} destaque={!ladoAdv && l.pts >= 20} />)}
              <tr className="tot">
                <td className="n">TOTAL</td><td />
                <td style={{ fontWeight: 800 }}>{mostrado.score}</td>
                <td>{mostrado.totals.fgm}/{mostrado.totals.fga}</td>
                <td>{mostrado.totals.tpm}/{mostrado.totals.tpa}</td>
                <td>{mostrado.totals.ftm}/{mostrado.totals.fta}</td>
                <td>{mostrado.totals.orb + mostrado.totals.drb}</td>
                <td>{mostrado.totals.ast}</td>
                <td>{mostrado.totals.tov}</td><td /><td />
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {box.log && box.log.length > 0 && (
        <>
          <h2>Como terminou</h2>
          <div className="card tight">
            {box.log.slice(-8).reverse().map((ev, i) => {
              const mm = Math.floor(Math.max(ev.clock, 0) / 60);
              const ss = Math.floor(Math.max(ev.clock, 0) % 60);
              return (
                <div key={i} className="row" style={{ padding: '6px 0', gap: 12, alignItems: 'baseline' }}>
                  <span className="dim tabular small" style={{ minWidth: 56 }}>
                    {ev.q}Q {mm}:{String(ss).padStart(2, '0')}
                  </span>
                  <span className="small">{ev.text}</span>
                </div>
              );
            })}
          </div>
        </>
      )}
      <div style={{ height: 24 }} />
      {void POSITION_LABEL}
    </>
  );
}
